const guideLineBaseWidth = 375;
const guideLineBaseHeight = 812;

export const horizontalScale = (size) => (window.innerWidth / guideLineBaseWidth) * size;
export const verticalScale = (size) => (window.innerHeight / guideLineBaseHeight) * size;
export const moderateScale = (size, factor = 0.5) => size + (horizontalScale(size) - size) * factor;
